import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader, callApi } from "../Helpers";
import {
    STR_REPORT_PROBLEM,
    STR_SEND,
    STR_DESCRIPTION,
    STR_DESCRIPTION_SUMMARY,
    STR_SUCCESS,
} from "../Strings";
export default function View(props) {
    const appContext = useContext(AppContext);


    const [ready, setReady] = useState(false);
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);

    async function init() {
        setReady(false);
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    const handleSubmit = async () => {
        setLoading(true);


        await callApi("report-problem", {
            description
        }).then((response) => {
            if (response.status === 1) {
                appContext.tellMessage(STR_SUCCESS[appContext.language]);
                appContext.navBack();
            } else {
                appContext.tellError(response.msg);
            }
        });

        setLoading(false);
    };

        useEffect(() => {
            appContext.setShowOverlayLoader(loading);
        }, [ loading ])

    if (ready) {
        return (
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    overflow: "scroll",
                    paddingTop: "20px",
                }}
                className="mNoScrollBar"
            >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row" style={{ marginTop: "10px", marginBottom: "30px" }}>
                                <div className="col-md-12">
                                    <h6
                                        style={{
                                            fontSize: "28px",
                                        }}
                                        className="font-light"
                                    >
                                        {STR_REPORT_PROBLEM[appContext.language]}
                                    </h6>
                                </div>

                                <h5 className="mt-3">{STR_DESCRIPTION_SUMMARY[appContext.language]}</h5>
                                <div className="mb-3 mt-3">
                                    <label className="form-label">{STR_DESCRIPTION[appContext.language]}</label>
                                    <textarea
                                        className="form-control"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        disabled={loading}
                                        rows={4}
                                    />

                                </div>

                                <div className="mb-3 mt-3 text-end">
                                    <button
                                        className="btn btn-rounded bg-secondary btn-padded"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                    >
                                        {loading ? "..." : STR_SEND[appContext.language]}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div
                className="mSupportLoading"
                style={{
                    width: "100%",
                    height: "100%",
                }}
            >
                {getInlineLoader()}
            </div>
        );
    }
}
